import { createContext, useState } from "react";

const HelpContext = createContext({});

export const HelpProvider = ({ children }) => {
  const [showHelp, setShowHelp] = useState(false);
  const [perek, setPerek] = useState("");
  const [saeef, setSaeef] = useState("");

  return (
    <HelpContext.Provider
      value={{ showHelp, setShowHelp, perek, setPerek, saeef, setSaeef }}
    >
      {children}
    </HelpContext.Provider>
  );
};

export default HelpContext;
